module.exports = __webpack_public_path__ + "img/shuttle-domestic.22979554.jpg";